import { getExhibitionsDetail, getCurrentExhibition } from '@/calls/exhibitions';
import router from '@/router';

const exhibitions = {
  namespaced: true,
  state: {
    requests: 0,
    item: null,
    current: { id: 0, slug: '', lang: '' }
  },
  mutations: {
    setItem(state, item) {
      state.item = item;
    },
    setCurrent(state, item) {
      state.current = item;
    },
    increaseRequests(state) {
      state.requests += 1;
    },
    decreaseRequests(state) {
      state.requests -= 1;
    }
  },
  actions: {
    async getDetail({ commit }, { id, loc }) {
      commit('increaseRequests');
      try {
        const response = await getExhibitionsDetail(id, loc);
        commit('setItem', response);
      } catch (e) {
        commit('setItem', null);
        const lang = localStorage.getItem('lang') || 'ko';
        router.push({ name: 'PageError', params: { locale: lang } });
      }
      commit('decreaseRequests');
    },
    async getCurrent({ commit, state }, { loc }) {
      commit('increaseRequests');
      try {
        const response = await getCurrentExhibition(loc);
        // console.log('desactivate', 'current exhibition', response);
        commit('setCurrent', response);
        router.push({
          name: 'Login',
          params: {
            locale: state.current.lang,
            id: state.current.slug
          }
        });
      } catch (e) {
        const lang = localStorage.getItem('lang') || 'ko';
        // console.log('desactivate','failed get current', e);
        commit('setItem', null);
        commit('setCurrent', { id: 0, slug: '', lang: '' });
        router.push({ name: 'NoExhibition', params: { locale: lang } });
      }
      commit('decreaseRequests');
    }
  }
};

export default exhibitions;
